'use strict';

import './component.scss';
import loading from 'components/loading';
import isEnterOrSpacebarPressed from 'components/complement/isEnterOrSpacebarPressed';

const CTA_CONTAINER = document.querySelector('.cta-wrapper');
const CTA_BUTTON = CTA_CONTAINER && CTA_CONTAINER.querySelector('a.button');
const isLoaderAfterCtaActive = document.documentElement.dataset.loaderAfterCta;

function init () {
    if (!isLoaderAfterCtaActive) {
        return;
    }

    if (!CTA_BUTTON) {
        return;
    }

    attachEventListeners();
}

function attachEventListeners () {
    CTA_BUTTON.addEventListener('click', handleLoader);
    CTA_BUTTON.addEventListener('keyup', (e) => {
        isEnterOrSpacebarPressed(e) && handleLoader()
    })
}

function handleLoader() {
    loading.showDynamic(CTA_BUTTON.dataset)
}

window.addEventListener('DOMContentLoaded',  init);
